<div *ngIf="project" class="fx-layout-row fx-align--x-center fx-gap--16px fx-gap--4px--xs fx-align--space-between-x">
  <div class="samples-heading" *ngIf="project.primaryProduct === 'SAMPLE'">
    <h1>Product Samples</h1>
    <i>Individual Samples are $1 each and receive a coupon credit for up to <strong>$20 off</strong> your next non-sample purchase!</i>
  </div>

  <div class="action-bar fx-layout-row fx-align--x-center fx-gap--16px fx-gap--4px--xs fx-align--space-between-x">
    <div class="current-price fx-layout-row fx-gap--32px--lt-lg fx-gap--32px--gt-md">
      <div>
        <div class="heading">Count</div>
        <div>
          <!--
              <input id="suggestion-qty" class="rounded" type="number" mbnmQty [(ngModel)]="project.qty" (keyup)="updateExamplePrices()" [matAutocomplete]="qtyAuto"/>
              <mat-autocomplete #qtyAuto="matAutocomplete" panelWidth="280px">
                <mat-option [disabled]="true" class="heading">
                  Volume Discounts Available
                </mat-option>
                @for (option of options; track option) {
                <mat-option class="qty-options" [value]="option.qty">
                  <span class="sm">buy </span>
                  <strong>{{option.qty}}</strong>
                  <span class="sm"> and save </span>
                  <strong class="green">{{ option.savings | percent:'1.0-0' }}</strong>
                </mat-option>
                }
              </mat-autocomplete>
              -->
          <span *ngIf="project.primaryProduct === 'SAMPLE'" class="sample-count">{{project.numSamples}}</span>
          <input *ngIf="project.primaryProduct !== 'SAMPLE'" id="no-suggestion-qty" class="rounded" type="number" min="1" mbnmQty [(ngModel)]="project.qty" />
        </div>
      </div>

      <div *ngIf="completionText">
        <span class="tiny-text" [innerHtml]="completionText"></span>
      </div>

      <ng-container *ngIf="!completionText">
        <div *ngIf="project.primaryProduct !== 'SAMPLE'">
          <div class="heading">
            Each
            <mat-icon *ngIf="project.primaryProduct !== 'SAMPLE'"
                      (click)="unitPriceInfoClicked()" svgIcon="information-outline">
            </mat-icon>
          </div>
          <div class="unit-price" [ngClass]="{faded: project.longUpdate}">
            <ng-container *ngIf="project.qty > 0 && !project.size.incomplete">
              <s *ngIf="project.price < project.maxPrice" [innerHtml]="project.maxPrice | currency2"></s>
              <span class="currency" [innerHtml]="project?.price | currency2"></span>
              <span class="savings" *ngIf="project.price < project.maxPrice">
                      You Save {{(1 - project.price / project.maxPrice) | percent:'1.0-0'}}
                <!--<br />
                <strong [innerHtml]="project.qty * (project.maxPrice - project.price) | currency2"></strong> Overall!-->
                  </span>
            </ng-container>
            <ng-container *ngIf="!project.qty || project.size.incomplete" [ngClass]="{faded: project.longUpdate}">
              <span>from </span>
              <span class="currency" [innerHtml]="project.minPrice | currency2"></span>
              <span class="savings">for 1000+</span>
            </ng-container>
            <div class="hide-gt-md" *ngIf="project.primaryProduct !== 'SAMPLE' && project.qty > 1" >
              (<span class="currency small" [innerHtml]="project.qty * project.price | currency2" [ngClass]="{faded: project.longUpdate}"></span> total)
            </div>
            <mat-progress-bar *ngIf="project.longUpdate" mode="indeterminate"></mat-progress-bar>
          </div>
        </div>
        <div class="hide-lt-lg">
          <div class="heading">
            <ng-container *ngIf="project.primaryProduct === 'SAMPLE'">Total Price</ng-container>
            <ng-container *ngIf="project.primaryProduct !== 'SAMPLE'">Total</ng-container>
          </div>
          <div>
            <span *ngIf="project.primaryProduct === 'SAMPLE'" class="currency" [innerHtml]="project.numSamples * project.price | currency2"></span>
            <span *ngIf="project.primaryProduct !== 'SAMPLE'" class="currency" [innerHtml]="project.qty * project.price | currency2" [ngClass]="{faded: project.longUpdate}"></span>
          </div>
        </div>
      </ng-container>
      <div *ngIf="project.primaryProduct === 'SAMPLE'">
        <div class="heading">
          <ng-container *ngIf="project.primaryProduct === 'SAMPLE'">Total Price</ng-container>
        </div>
        <div>
          <span *ngIf="project.primaryProduct === 'SAMPLE'" class="currency" [innerHtml]="project.numSamples * project.price | currency2"></span>
        </div>
      </div>
    </div>

    <div class="action-btn">
      <button mat-flat-button color="primary" (click)="addToCartClicked($event)" [disabled]="canDisableAddToCart && project.updating">
          <span>
            {{project.originalId ? 'Save Changes' : 'Add to ' + (currentCartIsOrder ? 'Order' : 'Cart')}}
          </span>
      </button>
      <a class="cancel-edit" *ngIf="project.originalId" (click)="cancelEditClicked()">
        cancel edit
      </a>
    </div>
  </div>
</div>
